import React from "react";
import PropTypes from "prop-types";
import { RlNavContext } from "./RlNav";

const RlNavContentItem = ({ navKey, children }) => {
  const { activeKey } = React.useContext(RlNavContext);
  return activeKey === navKey ? children : null;
};
RlNavContentItem.propTypes = {
  navKey: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
export default RlNavContentItem;
